"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMetaBlockConfig = void 0;
var stitchLink_1 = require("../../../../utils/stitchLink");
var createFormattedDate_1 = require("../../../../utils/momentjs/createFormattedDate");
var getVal_1 = require("../../../../utils/getterSetterDeleter/getVal");
var parseMetaBlockConfig = function (_a) {
    var config = _a.config, localize = _a.localize, data = _a.data;
    if (!config)
        return [];
    //else
    return config
        .map(function (d) {
        var key = d.key, valuePath = d.valuePath, prefix = d.prefix, icon = d.icon, linkConfig = d.linkConfig;
        var display;
        switch (key) {
            case "name":
                display = (0, getVal_1.getVal)(data, valuePath);
                if (display && typeof display === 'string') {
                    //reduce surname down to initials
                    var split = display.split(" ");
                    var name_1 = split[0];
                    var surname = split[1];
                    display = "".concat(name_1).concat(surname ? " ".concat(surname[0], ".") : "");
                }
                break;
            case "date":
                display = (0, createFormattedDate_1.createFormattedDate)((0, getVal_1.getVal)(data, valuePath));
                break;
            case "text":
            default:
                display = (0, getVal_1.getVal)(data, valuePath);
        }
        if (prefix) {
            display = "".concat(localize(prefix)).concat(display);
        }
        var toReturn = { display: display };
        //now to incorporate things like icons, imgs, links
        if (icon)
            toReturn.icon = icon;
        if (linkConfig)
            toReturn.to = (0, stitchLink_1.stitchLink)({ data: data, config: linkConfig });
        return toReturn;
    })
        .filter(function (d) { return d.display !== undefined; });
};
exports.parseMetaBlockConfig = parseMetaBlockConfig;
